export const COOKIESPOLICY_CMS_DATA = 'COOKIESPOLICY_CMS_DATA';
export const COOKIESPOLICY_TABLE_CMS_DATA = 'COOKIESPOLICY_TABLE_CMS_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
